// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../dashboard-mellow-embed-clipboard/node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../dashboard-mellow-embed-clipboard/node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.apps[data-v-5c8ee0b6]  .state-description{color:var(--error)}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
